import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRectangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 6,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M.859 0H6.14a.727.727 0 01.605 1.13l-2.64 3.962a.727.727 0 01-1.211 0L.254 1.131A.727.727 0 01.859 0z",
		fill: "#535066",
		fillRule: "evenodd"
	})
});
export default SvgRectangle;
